import React from 'react';
import cx from 'classnames';
import { useSelector } from 'redux/hooks';
import { selectOffersLeaderboards } from 'redux/modules/banners/selectors';
import { transformSearchResultToCitrusTradingCell } from 'utils/adtech/transform-searchresult-to-tradingcell-props';
import { type FullWidthNavigationProps } from 'content/components/types';
import { FullWidthNavigationWrapper } from 'components/adtech/FullWidthNavigationWrapper';
import styles from './Leaderboard.scss';

export const OffersLeaderboards = () => {
  const banners = useSelector(selectOffersLeaderboards);
  return (
    <section
      id="leaderboards"
      aria-label="Offers leaderboards"
      className={cx('container-fluid', styles.cell, styles.offers)}
    >
      {banners.map(banner => (
        <FullWidthNavigationWrapper
          {...{
            ...transformSearchResultToCitrusTradingCell({
              index: 0,
              position: '',
              component: {
                banner: {
                  ...banner,
                  image: {
                    altText: '',
                    mode: '',
                    ...banner.image,
                  },
                  textArea: banner.textArea as FullWidthNavigationProps & { color: string },
                  cqResponsive: { deviceBreakpoints: [] },
                  gridPosition: '0',
                  adTechPosition: '',
                  name: '',
                },
              },
              searchType: '',
            }),
            ...(banner.textArea.offerHeading && {
              icons: {
                messageIcon: {
                  display: true,
                  data: {
                    message: banner.textArea.offerHeading,
                  },
                },
                offerRoundel: {
                  display: true,
                  image: {
                    altText: 'Offers',
                    src: '/content/dam/waitrosegroceriescms/icons/offerroundels/offers.png',
                  },
                },
              },
            }),
          }}
          key={banner.id}
        />
      ))}
    </section>
  );
};
